import React, { Fragment } from 'react';

export default () => (
  <Fragment>
    <h1 className="header__title">
      Chat
    </h1>
  </Fragment>
);
